import React, { useContext } from "react";
import heroImg from "../../../images/LandingPageImage/dhroom_cta.webp";
import { Link } from "react-router-dom";
import MyContext from "../../../MyContext";

const CtaSection = () => {
  const { openFreeTrialModal } = useContext(MyContext);
  return (
    <>
      <style>{`
        .cta-wrapper {
          background: #ffffff;
          padding-top: 3rem; 
          padding-bottom: 3rem;
        } 

        .cta-box {
          background: linear-gradient(to right, #2F2CD8, #1E1B4B);
          border-radius: 16px;
          padding: 30px;
          padding-bottom: 0;
        }

        .cta-image-col {
          margin-bottom: -30px;
        }

        .cta-box h2,
        .cta-box p {
          color: #ffffff;
        }

        .cta-buttons {
          justify-content: flex-start;
        }

        .free-button {
          border: 1.5px solid #2F2CD8;
          color: #ffffff;
          background: #4B63FF;
          transition: all 0.25s ease;
        }

        .free-button:hover {
          background: transparent;
          color: #ffffff;
          border: 1.5px solid #ffffff;
        }

        @media (max-width: 991px) {
          .cta-box {
            text-align: center;
            padding-bottom: 0;
          }
          .cta-buttons {
            justify-content: center;
          }
        }

        @media (max-width: 576px) {
          .cta-box {
            padding: 20px;
            padding-bottom: 0;
          }

          .cta-box h2 {
            font-size: 24px;
          }
        }
          .hero-img {
  max-height: 300px;
}

@media (max-width: 768px) {
  .hero-img {
    max-height: 280px;
  }
}

      `}</style>

      <div className="cta-wrapper">
        <div className="container">
          <div className="cta-box">
            <div className="row align-items-center">
              {/* LEFT */}
              <div className="col-lg-6 col-md-12 mb-3 mb-lg-0">
                <h2 className="fw-bold mb-3 text-white">
                  Get Started with Dhroom Today
                </h2>

                <p className="mb-4 text-white">
                  Interact directly with our product experts and get answers to
                  your specific challenges.
                </p>
                <div className="cta-buttons d-flex gap-3 flex-wrap">
                  <button
                    onClick={openFreeTrialModal}
                    className="free-button rounded-pill px-4 p-2 text-decoration-none d-inline-block"
                  >
                    Start Free Trial
                  </button>

                  <Link
                    to="/pricing-page"
                    className="free-button rounded-pill px-4 p-2 text-decoration-none d-inline-block"
                  >
                    See Pricing
                  </Link>
                </div>
              </div>

              {/* RIGHT */}
              <div className="col-lg-6 col-md-12 d-flex align-items-end justify-content-center">
                <img src={heroImg} alt="CTA" className="img-fluid hero-img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CtaSection;
